import {
  STAGING_WINTER_BRAND_CAMPAIGN_2025_START_TIME,
  WINTER_BRAND_CAMPAIGN_2025_START_TIME,
} from '@/shared/constants/winter-brand-campaign-2025'
import { isProd } from '@/shared/utils'
import { isAfterTime } from '@/utils/date'

/**
 * @desc:
 * - 2025 겨울 브랜드 캠페인
 * -25.11.17 12:00 ~ 아마 내년 중순?
 *
 * @return:
 * - boolean
 */
export const isWinterBrandCampaignPeriod = () => {
  return isProd
    ? isAfterTime(WINTER_BRAND_CAMPAIGN_2025_START_TIME)
    : isAfterTime(STAGING_WINTER_BRAND_CAMPAIGN_2025_START_TIME)
}
